module.exports = __webpack_public_path__ + "static/media/processed.117266e9.jpeg";